import { Companion_getInstance2u620q9r4ejbj as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { BorderDashStyle_Dashed_getInstance2gd3qu91rajbi as BorderDashStyle_Dashed_getInstance } from './DashedBorder.mjs';
import { get_native16zxqjg6lrtlz as get_native } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.commonHtml.mjs';
import { _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function dashedBorder(_this__u8e3s4, borderColor, borderWidth, style) {
  borderColor = borderColor === VOID ? Companion_getInstance().gray_u3prp_k$(0.6) : borderColor;
  borderWidth = borderWidth === VOID ? get_px(1) : borderWidth;
  style = style === VOID ? BorderDashStyle_Dashed_getInstance() : style;
  get_native(_this__u8e3s4).setStyleProperty_wavvb3_k$('border-style', style.cssValue_1);
  get_native(_this__u8e3s4).setStyleProperty_wavvb3_k$('border-width', _Dimension___get_value__impl__urhqzr(borderWidth).toString());
  get_native(_this__u8e3s4).setStyleProperty_wavvb3_k$('border-color', borderColor.toWeb_1tsvdl_k$());
}
//region block: exports
export {
  dashedBorder as dashedBorderm8lc8ko2pq4e,
};
//endregion

//# sourceMappingURL=DashedBorder.js.mjs.map
